module.exports = __webpack_public_path__ + "images/icons/icon-payment-discover-948bd288.svg";